/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import {
  Grid,
  Paper,
  TextField,
  Button,
  Autocomplete,
  Checkbox,
  Box,
  Typography,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import api from '../../utils/functions/api';
import TableHistory from './TableHistory';
import { getStorage } from '../../utils/functions/localstorage';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import IconButton from '@mui/material/IconButton';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SpeedDial from '@mui/material/SpeedDial';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import Loading from '../../components/Loading';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function History() {
  const [allData, setAllData] = useState([]);
  const [ishistory, setIShistory] = useState([]);
  const [allHistory, setAllHistory] = useState([]);
  const [totalAmount, setTotalAmount] = useState('');
  const [startDateFilter, setStartDateFilter] = useState(
    dayjs().startOf('month').format('YYYYMMDD'),
  );
  const [endDateFilter, setEndDateFilter] = useState(
    dayjs().format('YYYYMMDD'),
  );
  const [orderDirection, setOrderDirection] = useState('asc');
  const [valueToOrderBy, setValueToOrderBy] = useState('');
  const [pagination, setPagination] = useState({
    currPage: 1,
    size: 10,
    totalItems: 0,
    totalPages: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMerchants, setSelectedMerchants] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]); // New state for selected status
  const [merchOpt, setMerchOpt] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchTrigger, setSearchTrigger] = useState(false);
  const [statusOptions, setStatusOptions] = useState([
    { label: 'Pending', value: 'pending' },
    { label: 'Success', value: 'success' },
    // { label: 'Reject', value: 'reject' },
    { label: 'Fail', value: 'fail' },
  ]);

  const fetchMerchants = async () => {
    try {
      const path = `${process.env.REACT_APP_APIHOST}/company/data/all`;
      const { data } = await api.get(path, {
        headers: { Authorization: getStorage('token') },
      });
      setMerchOpt(data.filter((merchant) => merchant.name));
    } catch (e) {
      throw new Error(e);
    }
  };

  const history = async (page = 1, size = 10) => {
    try {
      setIsLoading(true);

      const mkeyFilter = selectedMerchants.join(',');
      const statusFilter = selectedStatus.join(',');

      const path = `${process.env.REACT_APP_APIHOST}/eentry/orderpayment/transactions?start_date=${startDateFilter}&end_date=${endDateFilter}&page=${page}&limit=${size}&search=${searchText}`;

      const { data } = await api.get(path, {
        headers: { Authorization: getStorage('token') },
      });

      setAllHistory(data.data || []);
      setIShistory(data.data || []);
      setTotalAmount(data);

      const { pagination } = data;
      setPagination({
        currPage: pagination.currentPage,
        size: pagination.pageSize,
        totalItems: pagination.totalItems,
        totalPages: pagination.totalPages,
      });

      setIsLoading(false);
      return data;
    } catch (e) {
      setIsLoading(false);
      throw new Error(e);
    }
  };

  useEffect(() => {
    history(pagination.currPage, pagination.size);
  }, [pagination.currPage, pagination.size]);

  useEffect(() => {
    fetchMerchants();
  }, []);

  const handleMerchantChange = (event, newValueMerchant) => {
    if (newValueMerchant) {
      const newMerchantIds = newValueMerchant.map((option) => option.mkey);
      setSelectedMerchants(newMerchantIds);
    } else {
      setSelectedMerchants([]);
    }
  };

  const handleStatusChange = (event, newValueStatus) => {
    setSelectedStatus(newValueStatus.map((option) => option.value));
  };

  const handleRequestSort = (event, property) => {
    const isAscending = valueToOrderBy === property && orderDirection === 'asc';
    setValueToOrderBy(property);
    setOrderDirection(isAscending ? 'desc' : 'asc');
  };

  const handlePaginationChange = (type, value) => {
    if (type === 'handleChangePage') {
      setPagination((prev) => ({ ...prev, currPage: value }));
    } else if (type === 'handleChangeRowsPerPage') {
      setPagination({ ...pagination, size: value, currPage: 1 });
    }
  };

  const onClickSubmit = async () => {
    setIsLoading(true);
    await history(); // ตอนนี้ history() handle ทุก filter แล้ว
    setPagination((prev) => ({ ...prev, currPage: 1 }));
    setIsLoading(false);
  };

  const onClickCancel = () => {
    setSelectedMerchants([]);
    setSelectedStatus([]);
    setStartDateFilter(dayjs().startOf('month').format('YYYYMMDD'));
    setEndDateFilter(dayjs().format('YYYYMMDD'));
    setSearchText('');
    setPagination({ currPage: 1, size: 10, lastPage: 1, total: 0 });
    setSearchTrigger(true);
    window.location.reload();
  };

  const [direction, setDirection] = React.useState('left');
  const download = [
    { icon: <FontAwesomeIcon icon={faFileExcel} size="xl" />, name: 'EXCLE' },
    { icon: <FontAwesomeIcon icon={faFilePdf} size="xl" />, name: 'PDF' },
  ];

  const prepareDataDownload = async (
    typeDownload,
    valueHeader,
    fileName,
    valueOption,
  ) => {
    const headers = { Accept: 'application/json' };
    try {
      let apiUrl = '';
      if (typeDownload === 'pdf') {
        apiUrl = `${process.env.REACT_APP_APIHOST}/merchant/transaction/pdf`;
      } else if (typeDownload === 'csv') {
        apiUrl = `${process.env.REACT_APP_APIHOST}/merchant/transaction/excel`;
      }

      // Make the request to the API
      const response = await api.post(apiUrl, allData, {
        responseType: 'arraybuffer', // Ensure the response is treated as binary data
        headers,
      });

      const now = new Date();
      const day = now.getDate().toString().padStart(2, '0');
      const month = (now.getMonth() + 1).toString().padStart(2, '0');
      const year = now.getFullYear().toString();
      const formattedDate = `${day}-${month}-${year}`;

      const outputFilename = `transaction-report-${formattedDate}.${
        typeDownload === 'pdf' ? 'pdf' : 'xlsx'
      }`;

      // Create a blob from the response data
      const blob = new Blob([response.data], {
        type:
          typeDownload === 'pdf'
            ? 'application/pdf'
            : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      // Create a download link
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();

      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      console.error('Error downloading file:', e);
      throw new Error(e);
    }
  };

  const handleDownloadExcel = async () => {
    try {
      setIsLoading(true);

      const start = dayjs(startDateFilter).format('YYYYMMDD');
      const end = dayjs(endDateFilter).format('YYYYMMDD');
      const search = encodeURIComponent(searchText || '');

      const url = `${process.env.REACT_APP_APIHOST}/eentry/orderpayment/transactions/excel?start_date=${start}&end_date=${end}&search=${search}`;

      const token = getStorage('token');

      const response = await api.get(url, {
        headers: {
          Authorization: `${token}`, // อย่าลืม Bearer
        },
        responseType: 'blob', // สำคัญมาก!
      });

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const fileName = `E-Entry Transaction ${dayjs().format(
        'DD-MM-YYYY',
      )}.xlsx`;
      saveAs(blob, fileName);
    } catch (error) {
      console.error('❌ Download Excel failed:', error);
      alert('ไม่สามารถดาวน์โหลดไฟล์ได้');
    } finally {
      setIsLoading(false);
    }
  };

  const renderFilterFormHistory = () => (
    <form>
      <Grid container spacing={3} style={{ marginTop: '8px' }}>
        <Grid container item spacing={3} xs={12}>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            style={{ marginLeft: '20px', marginRight: '10px' }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="วันที่เริ่มสร้างรายการ"
                disableFuture
                inputFormat="DD/MM/YYYY"
                value={startDateFilter}
                minDate={dayjs().subtract(10, 'year')}
                maxDate={dayjs().add(10, 'year')}
                onChange={(value) => {
                  setStartDateFilter(dayjs(value).format('YYYYMMDD'));
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            style={{ marginLeft: '20px', marginRight: '10px' }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="วันที่สิ้นสุดสร้างรายการ"
                disableFuture
                inputFormat="DD/MM/YYYY"
                value={endDateFilter}
                minDate={dayjs().subtract(10, 'year')}
                maxDate={dayjs().add(10, 'year')}
                onChange={(value) => {
                  setEndDateFilter(dayjs(value).format('YYYYMMDD'));
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
        <Grid container item spacing={3} xs={12}>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            style={{ marginLeft: '20px', marginRight: '10px' }}
          >
            <TextField
              className="text"
              label="ค้นหาข้อความ :"
              variant="outlined"
              size="small"
              fullWidth
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={12}
          justifyContent="space-between"
          alignItems="center"
          style={{ marginLeft: '20px', marginRight: '20px' }}
        >
          <Grid item>
            <Button
              onClick={onClickSubmit}
              variant="outlined"
              color="success"
              size="medium"
              sx={{ mr: 2 }}
            >
              ยืนยัน
            </Button>
            <Button
              onClick={onClickCancel}
              variant="outlined"
              color="error"
              size="medium"
            >
              รีเซ็ต
            </Button>
          </Grid>

          <Grid item>
            <Button
              variant="outlined"
              color="primary"
              size="medium"
              onClick={handleDownloadExcel}
              startIcon={<FileDownloadIcon />}
            >
              ดาวน์โหลด Excel
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );

  const sum = () => <div>{totalAmount.total_amount || 0} บาท</div>;
  const count = () => <div>{totalAmount.count || 0} รายการ</div>;
  return (
    <Grid container>
      <Loading isLoading={isLoading} />

      <Grid item xs={12} md={12}>
        <div className="font-bold text-xl" style={{ marginLeft: '20px' }}>
          ประวัติการทำรายการ
        </div>
      </Grid>
      <Grid item xs={12} md={12}>
        {renderFilterFormHistory()}
      </Grid>
      <Grid item xs={12} md={12}>
        <Paper
          sx={{
            overflow: 'hidden',
            marginTop: '20px',
            marginLeft: { xs: '10px', sm: '15px', md: '20px' },
            marginRight: { xs: '10px', sm: '15px', md: '20px' },
            marginBottom: '10px',
          }}
        >
          <TableHistory
            ishistory={ishistory}
            handleRequestSort={handleRequestSort}
            valueToOrderBy={valueToOrderBy}
            orderDirection={orderDirection}
            pagination={pagination}
            handlePaginationChange={handlePaginationChange}
          />
        </Paper>
      </Grid>
    </Grid>
  );
}

export default History;
